"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LambdaFunctionConfiguration_1 = require("./_LambdaFunctionConfiguration");
exports._LambdaFunctionConfigurationList = {
    type: "list",
    flattened: true,
    member: {
        shape: _LambdaFunctionConfiguration_1._LambdaFunctionConfiguration
    }
};
//# sourceMappingURL=_LambdaFunctionConfigurationList.js.map